import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-invoice-items',
  templateUrl: './add-invoice-items.component.html',
  styleUrls: ['./add-invoice-items.component.css']
})
export class AddInvoiceItemsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
